<template>
  <jt-card-default
    :shouldShowSelectDay="true"
    :cardSelectType="0"
    :shouldShowFullscreen="false"
    @change="onChangeSelectDate"
  >
    <div v-if="isLoading" class="div-loader">
      <div class="spinning-loader rotate"></div>
    </div>

    <br>
    <br>

      <q-markup-table separator="none" class="bg-blue-grey-2">
        <thead>
          <tr>
            <th colspan="3">
              <div class="text-h6">{{this.$gettext('DASHBOARD_RECEIPT')}}</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th colspan="3">
              <hr />
            </th>
          </tr>
          <tr>
            <th class="text-left w-2"></th>
            <th class="text-center">{{this.$gettext('DASHBOARD_RECEIPT_TONNE')}}</th>
            <th class="text-center">{{this.$gettext('DASHBOARD_RECEIPT_VEHICLE')}}</th>
          </tr>
          <tr v-for="item in rowsTonneVehicle" :key="item">
            <td class="text-right w-5">{{ item.name }}</td>
            <td class="text-center">
              <q-chip
                square
                size="md"
                color="white"
                class="text-center full-width"
              >
                <div class="text-center full-width">{{ item.tonne }}</div>
              </q-chip>
            </td>
            <td class="text-center">
              <q-chip
                square
                size="md"
                color="white"
                class="text-center full-width"
                ><div class="text-center full-width">
                  {{ item.vehicle }}
                </div></q-chip
              >
            </td>
          </tr>

          <tr>
            <th colspan="3">
              <hr />
            </th>
          </tr>
          <tr>
            <th colspan="3">
              <div class="text-h7">{{this.$gettext('DASHBOARD_RECEIPT_AVG_TIME_MIN')}}</div>
            </th>
          </tr>
          <tr>

            <td v-for="item in rowsAvgTimeDischarge" :key="item" class="text-center">
              <div> {{ item.name }}</div>
              <q-chip
                square
                size="md"
                color="white"
                class="text-center full-width"
                ><div class="text-center full-width">
                  {{ item.time }}
                </div></q-chip
              >
            </td>

          </tr>
          <tr>
            <th colspan="3">
              <hr />
            </th>
          </tr>
          <tr>
            <th colspan="3">
              <div class="text-h7">{{this.$gettext('DASHBOARD_RECEIPT_AVG_TIME_MIN_VEHICLE_MONTH')}}</div>
            </th>
          </tr>
          <tr>
            <td class="text-center" colspan="3">
              <q-chip
                square
                size="md"
                color="white"
                class="text-center full-width"
                ><div class="text-center full-width">
                  {{ avgTimeVehiclePerDayDischarge }}
                </div></q-chip
              >
            </td>
          </tr>
        </tbody>
      </q-markup-table>

  </jt-card-default>
</template>
<script>
import JtCardDefault from 'src/components/dashboard/dashboard-card-components/base/JtCardDefault.vue'
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import moment from 'moment'

@Component({
  name: 'Receivement',
  components: {
    JtCardDefault
  }
})
export default class Receivement extends Vue {
  isLoading = false;

  currentDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate()
  };

  rowsTonneVehicle = [];
  rowsAvgTimeDischarge = [];
  avgTimeVehiclePerDayDischarge = 0;

  setZeros () {
    this.rowsTonneVehicle = [
      {
        name: 'Dia',
        tonne: 0,
        vehicle: 0
      },
      {
        name: 'Mês',
        tonne: 0,
        vehicle: 0
      },
      {
        name: 'Ano',
        tonne: 0,
        vehicle: 0
      },
      {
        name: 'Capac. Ope.',
        tonne: 0,
        vehicle: 0
      }
    ]

    this.rowsAvgTimeDischarge = [
      {
        name: 'Geral',
        time: 0
      },
      {
        name: 'Público',
        time: 0
      },
      {
        name: 'Privado',
        time: 0
      }
    ]
  }

  created () {
    this.onChangeSelectDate(this.currentDate)
  }

  onChangeSelectDate (date) {
    this.isLoading = true
    this.setDataTable(date)

    setTimeout(() => {
      this.isLoading = false
    }, 500)
  }

  setDataTable (date) {
    this.setZeros()
    this.setReceiptDay(date)
    this.setReceiptMonth(date)
    this.setReceiptYear(date)
    this.setReceiptOperationalCapacity(date)
    this.setAvgTimeGeneralDischarge(date)
    this.setAvgTimePublicDischarge(date)
    this.setAvgTimePrivateDischarge(date)
    this.setAvgTimeVehiclePerDayDischarge(date)
  }

  async setReceiptDay (date) {
    const { registros } = await repository.resolveDatatableModel(
      'entrance.hql',
      {
        grid: 'receiptDay',
        day: date.day,
        month: date.month,
        year: date.year
      }
    )

    if (registros.length != 0) {
      Object.keys(registros).forEach(function (key, index) {
        registros[key].tonne =
          parseFloat(registros[key].tonne.replaceAll('.', '')) / 1000
      })

      const data = registros.reduce((register) => register)

      this.rowsTonneVehicle[0].tonne = parseInt(data.tonne).toLocaleString('pt-BR')
      this.rowsTonneVehicle[0].vehicle = data.vehicle.toLocaleString('pt-BR')
    }
  }

  async setReceiptMonth (date) {
    const { registros } = await repository.resolveDatatableModel(
      'entrance.hql',
      {
        grid: 'receiptMonth',
        month: date.month,
        year: date.year
      }
    )

    if (registros.length != 0) {
      Object.keys(registros).forEach(function (key, index) {
        registros[key].tonne =
          parseFloat(registros[key].tonne.replaceAll('.', '')) / 1000
      })

      const data = registros.reduce((register) => register)

      this.rowsTonneVehicle[1].tonne = parseInt(data.tonne).toLocaleString('pt-BR')
      this.rowsTonneVehicle[1].vehicle = data.vehicle.toLocaleString('pt-BR')
    }
  }

  async setReceiptYear (date) {
    const { registros } = await repository.resolveDatatableModel(
      'entrance.hql',
      {
        grid: 'receiptYear',
        year: date.year
      }
    )

    if (registros.length != 0) {
      Object.keys(registros).forEach(function (key, index) {
        registros[key].tonne =
           parseFloat(registros[key].tonne.replaceAll('.', '')) / 1000
      })

      const data = registros.reduce((register) => register)

      this.rowsTonneVehicle[2].tonne = parseInt(data.tonne).toLocaleString('pt-BR')
      this.rowsTonneVehicle[2].vehicle = data.vehicle.toLocaleString('pt-BR')
    }
  }

  async setReceiptOperationalCapacity (date) {
    const { registros } = await repository.resolveDatatableModel(
      'entrance.hql',
      {
        grid: 'receiptOperationalCapacity',
        year: date.year,
        month: date.month
      }
    )

    if (registros.length != 0) {
      Object.keys(registros).forEach(function (key, index) {
        registros[key].tonne =
          parseFloat(registros[key].tonne.replaceAll('.', '')) / 1000
      })

      const maxTonneData = registros.reduce((max, atual) =>
        atual.tonne > max.tonne ? atual : max
      )

      this.rowsTonneVehicle[3].tonne = parseInt(maxTonneData.tonne).toLocaleString('pt-BR')

      const maxVehicleData = registros.reduce((max, atual) =>
        atual.vehicle > max.vehicle ? atual : max
      )
      this.rowsTonneVehicle[3].vehicle = maxVehicleData.vehicle.toLocaleString('pt-BR')
    }
  }

  async setAvgTimeGeneralDischarge (date) {
    const { registros } = await repository.resolveDatatableModel(
      'entrance.hql',
      {
        grid: 'avgTimeGeneralDischarge',
        year: date.year,
        month: date.month
      }
    )

    if (registros.length != 0) {
      const data = registros.reduce((register) => register)
      this.rowsAvgTimeDischarge[0].time = parseInt(data.time)
    }
  }

  async setAvgTimePublicDischarge (date) {
    const { registros } = await repository.resolveDatatableModel(
      'entrance.hql',
      {
        grid: 'avgTimePublicDischarge',
        year: date.year,
        month: date.month
      }
    )

    if (registros.length != 0) {
      const data = registros.reduce((register) => register)
      this.rowsAvgTimeDischarge[1].time = parseInt(data.time)
    }
  }

  async setAvgTimePrivateDischarge (date) {
    const { registros } = await repository.resolveDatatableModel(
      'entrance.hql',
      {
        grid: 'avgTimePrivateDischarge',
        year: date.year,
        month: date.month
      }
    )

    if (registros.length != 0) {
      const data = registros.reduce((register) => register)
      this.rowsAvgTimeDischarge[2].time = parseInt(data.time)
    }
  }

  async setAvgTimeVehiclePerDayDischarge (date) {
    const daysInMonth = moment().month(date.month - 1).daysInMonth()

    const { registros } = await repository.resolveDatatableModel(
      'entrance.hql',
      {
        grid: 'avgTimeVehiclePerDayDischarge',
        year: date.year,
        month: date.month
      }
    )

    if (registros.length != 0) {
      const data = registros.reduce((register) => register)
      this.avgTimeVehiclePerDayDischarge = Math.round(data.vehicle / daysInMonth)
    }
  }
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';

.q-chip {
  max-width: 180px;
}
</style>
